<template>
<div>
      <v-row>
        <v-col cols="6">
          <v-switch
            v-model="soloNonSaldati"
            label="Solo Non Saldati"
            class="ml-4"
            inset
          ></v-switch
        ></v-col>
        <v-col cols="6">
          <v-switch
            v-model="raggruppaPerCliente"
            label="Raggruppa per cliente"
            class="ml-4"
            inset
          ></v-switch>
        </v-col>
        <v-col cols="12">
          <v-autocomplete
            v-model="cliente"
            :items="clienti"
            label="Cliente"
            item-text="nome"
            item-value="iva"
            outlined
            hide-details
            clearable
          ></v-autocomplete>
        </v-col>
        <v-col cols="12">
          <v-select
            v-model="periodo"
            :items="periodoItems"
            label="Periodo"
            item-text="nome"
            item-value="value"
            outlined
            hide-details
          ></v-select>
        </v-col>
        <v-col cols="12">
          <v-select
            v-model="tipo"
            :items="tipoItems"
            label="Tipo"
            item-text="nome"
            item-value="value"
            outlined
            hide-details
          ></v-select>
        </v-col>
      </v-row>
    <v-card-text>
      <v-divider class="mt-4 mb-6"></v-divider>
      <template v-if="raggruppaPerCliente">
        <div v-for="(group, cliente) in groupedByCliente" :key="cliente">
          <v-row class="mb-1">
            <v-col cols="12" class="font-weight-bold">{{
              getCliente(cliente).nome
            }}</v-col>
          </v-row>
          <div v-for="(monthGroup, month) in group.contabili" :key="month">
            <v-row class="mb">
              <v-col cols="12" class="font-weight-light"
                ><u>{{ month }}</u></v-col
              >
            </v-row>
            <template v-for="contabile in monthGroup.contabili">
              <v-lazy :options="{ threshold: 0.7 }" :key="contabile.id">
                <contabile
                  @new_insert="refreshList"
                  :contabile="contabile"
                ></contabile>
              </v-lazy>
            </template>
            <v-row no-gutters class="mt-2">
              <v-col cols="12">
                Tot Mese: € {{ monthGroup.totale.toFixed(2) }}
                <span class="green--text mx-2"
                  > € {{ monthGroup.tot_verde.toFixed(2) }}</span
                >
                <span class="blue--text"
                  > € {{ monthGroup.tot_blu.toFixed(2) }}</span
                >
              </v-col>
            </v-row>
          </div>
          <v-row no-gutters class="mt-4">
            <v-col cols="12">
              <b>Totale: € {{ group.totale.toFixed(2) }}</b>
              <span class="green--text mx-2"
                > € {{ group.tot_verde.toFixed(2) }}</span
              >
              <span class="blue--text"
                > € {{ group.tot_blu.toFixed(2) }}</span
              >
            </v-col>
          </v-row>
          <v-divider class="mt-4 mb-6"></v-divider>
        </div>
      </template>
      <template v-else>
        <contabile
          v-for="contabile in contabili"
          @new_insert="refreshList"
          :key="contabile.id"
          :contabile="contabile"
        ></contabile>
      </template>
      <template v-if="contabili.length == 0">
        <v-row no-gutters>
          <v-col cols="12" class="text-center">
            Nessun Pagamento Registrato
          </v-col>
        </v-row>
      </template>
    </v-card-text>
    <v-dialog v-model="dialogInattivita" max-width="500" persistent>
      <v-card>
        <v-card-title class="headline">Inattività</v-card-title>
        <v-card-text>Sei ancora lì? Premi il pulsante per continuare.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="continua_navigazione">Continua</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</div>
</template>
  
  <script>
import contabile from "./contabile_mobile_element.vue";
import contabile_main_mixin from "../mixin/contabili_main_mixin";
export default {
  components: {
    contabile,
  },
  mixins: [contabile_main_mixin],
};
</script>